<script>
	
	import Wall from './Wall.svelte';
	import Form from './Form.svelte';

	const drawOutlines = false;

	const cols = [
		{hex:"#00FFFF",desc:"turquoise"},
		{hex:"#00FF00",desc:"green"},
		{hex:"#FFF100",desc:"yellow"},
		{hex:"#FF0000",desc:"red"},
		{hex:"#FF00BE",desc:"fuchsia"},
		{hex:"#FF8600",desc:"orange"},
		{hex:"#FFFFFF",desc:"white"}
	];
</script>

<svelte:head>
  <base href={__myapp.env.isProd ? 'wall/' : '/'}>
</svelte:head>

<Wall cols={cols} drawOutlines={drawOutlines}/>
<Form cols={cols}/>

<style>
	:global(body) {
        background-color: #000;
        color:white; 
		padding:0;
		margin:0;
		text-align:center;
    }
</style>
